import React from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <section className="hero-section">
      {/* Background Orbs */}
      <div className="glow-orb orb-1"></div>
      <div className="glow-orb orb-2"></div>
      <div className="glow-orb orb-3"></div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="badge-container">
            <span className="badge-dot"></span>
            <span className="badge-text">Visionary Software Solutions</span>
          </div>

          <h1 className="hero-title">
            Architecting the <br />
            <span className="gradient-text">Future of Tech</span> <br />
            with Excellence.
          </h1>

          <p className="hero-description">
            Award-winning software house specializing in Blockchain, AI
            development, and high-end Game Engineering. We turn complex
            challenges into seamless digital experiences.
          </p>

          <div className="hero-btns">
            <a href="/contactus" className="btn-primary main-cta">
              Get Started
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12H19M19 12L12 5M19 12L12 19"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
            <a href="/servicespage" className="btn-secondary secondary-cta">
              Our Expertise
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="visual-wrapper">
            {/* Floating Widgets */}
            <div className="floating-widget widget-1">
              <div className="widget-icon">💎</div>
              <div>
                <p className="widget-label">Web3.0</p>
                <p className="widget-status">Secured</p>
              </div>
            </div>

            <div className="floating-widget widget-2">
              <div className="widget-icon">🚀</div>
              <div>
                <p className="widget-label">Scalability</p>
                <p className="widget-status">Optimized</p>
              </div>
            </div>

            <img
              src="/blockchainlaptop.png"
              alt="Xperts House Tech"
              className="hero-main-img"
            />
            <div className="image-glow"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
